var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入编码" },
            model: {
              value: _vm.searchData.intentCode,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "intentCode", $$v)
              },
              expression: "searchData.intentCode"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入标准词槽" },
            model: {
              value: _vm.searchData.standardSlot,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "standardSlot", $$v)
              },
              expression: "searchData.standardSlot"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.checkPermission(["admin:admin:save"])
        ? _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addFun }
            },
            [_vm._v("新增")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "修改", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.row.id)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "600px",
            visible: _vm.newadd,
            "before-close": _vm.closeDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "意图编码：", prop: "intentCode" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.intentCode,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "intentCode", $$v)
                      },
                      expression: "addData.intentCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "词槽编码：", prop: "slot" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.slot,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "slot", $$v)
                      },
                      expression: "addData.slot"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "标准词槽：", prop: "standardSlot" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.standardSlot,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "standardSlot", $$v)
                      },
                      expression: "addData.standardSlot"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启用：", prop: "isEnabled" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.addData.isEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "isEnabled", $$v)
                        },
                        expression: "addData.isEnabled"
                      }
                    },
                    [_vm._v("启用")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.addData.isEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "isEnabled", $$v)
                        },
                        expression: "addData.isEnabled"
                      }
                    },
                    [_vm._v("禁用")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "textarea", rows: 5 },
                    model: {
                      value: _vm.addData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "remark", $$v)
                      },
                      expression: "addData.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }